import {
  IconProductVasTop16,
  IconProductVasAuction16,
  IconProductVasPremium16,
  IconProductVasStandard16,
} from '@cian/ui-kit-design-tokens/icons';

import { EVas, IVas } from '../../../types/offers';

export const VAS_MAP: {
  [type in EVas]: IVas;
} = {
  [EVas.Auction]: {
    name: 'Аукцион',
    description:
      'Аукцион – это способ увеличить частоту показов вашего объявления. Чем выше ставка, тем чаще ваше объявление будет показано в результатах поиска.',
    type: EVas.Auction,
  },
  [EVas.Top]: {
    name: 'Топ',
    description:
      'Топ-объявления самые заметные в результатах поиска за счёт больших фотографий и брендирования. Такие объявления показываются в 3 раза чаще обычных.',
    type: EVas.Top,
  },
  [EVas.Premium]: {
    name: 'Премиум',
    description:
      'Премиум-объявления выделены в результатах поиска за счёт брендирования. Такие объявления показываются в 1.5 раза чаще обычных.',
    type: EVas.Premium,
  },
  [EVas.Standard]: {
    name: 'Стандарт',
    description: 'Стандарт ниже объявлений с продвижением Топ и Премиум, но выше Публикаций в результатах поиска.',
    type: EVas.Standard,
  },
};

export const VAS_ICON_MAP = {
  [EVas.Auction]: <IconProductVasAuction16 color="icon-warning-default" />,
  [EVas.Top]: <IconProductVasTop16 color="icon-warning-default" />,
  [EVas.Premium]: <IconProductVasPremium16 color="icon-warning-default" />,
  [EVas.Standard]: <IconProductVasStandard16 color="icon-warning-default" />,
};
